import { Link } from "react-router-dom";
import EnquiryForm from "../components/common/EnquiryForm";

export default function PropertyManagement() {
  return (
    <main className="pt-16 md:pt-20">
      {/* Hero */}
      <section
        className="relative h-64 md:h-80 flex items-center justify-center bg-gray-700"
        style={{
          backgroundImage: "url('https://www.artistic-spaces.co.uk/assets/heros/hero-about.webp')",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <div className="absolute inset-0 bg-black/40" />
        <div className="relative z-10 text-center text-white px-4">
          <h1 className="text-3xl md:text-5xl font-semibold">Property Management</h1>
        </div>
      </section>

      {/* Content */}
      <section className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="flex flex-col gap-12">
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Looking for someone to manage your property?
            </h2>
            <p className="text-gray-600 leading-relaxed mb-6">
              If you own a commercial property and need a proactive management team, get in touch. Our expert team
              has been working in this sector for over 15 years, developing property management strategies based
              on hands-on experience and direct engagement with landlords and tenants.
            </p>
            <p className="text-gray-600 leading-relaxed mb-6">
              We take a creative and nimble approach to property management, offering management agreements,
              leasing solutions, and purchase options to maximise asset value. As a forward-thinking operator, we
              see opportunities where others don't and tailor solutions to unlock a property's full potential.
            </p>
            <Link
              to="/contact"
              className="inline-block px-6 py-2.5 bg-teal-700 text-white text-sm font-medium rounded hover:bg-teal-800 transition-colors duration-200"
            >
              Get in touch
            </Link>
          </div>

          <div className="border-t border-gray-200 pt-12">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Looking for someone to market your property?
            </h2>
            <p className="text-gray-600 leading-relaxed mb-6">
              Selling or letting commercial property is not always straightforward. In an uncertain market we have
              strived to make our portfolio work to its full potential. Over the years we have built on our
              relationships with agents and our clients to be able to provide the results we've required.
            </p>
            <p className="text-gray-600 leading-relaxed mb-6">
              If you are looking for an alternative angle of making your property work to its true potential
              through sale or letting then don't hesitate to get in touch.
            </p>
            <Link
              to="/contact"
              className="inline-block px-6 py-2.5 bg-teal-700 text-white text-sm font-medium rounded hover:bg-teal-800 transition-colors duration-200"
            >
              Get in touch
            </Link>
          </div>
        </div>
      </section>

      <EnquiryForm pageUri="https://artistic-spaces.co.uk/property-management" pageName="Property Management" />
    </main>
  );
}